const AGE_GROUP_LABELS: Record<string, string> = {
  AGE_3_5: '3-5',
  AGE_5_7: '5-7',
  AGE_7_10: '7-10',
  AGE_10_PLUS: '10+',
};

export function formatAgeGroup(ageGroup: string): string {
  return AGE_GROUP_LABELS[ageGroup] || ageGroup;
}
